'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _extends4 = require('babel-runtime/helpers/extends');

var _extends5 = _interopRequireDefault(_extends4);

exports.default = enhanceTranslate;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _server = require('react-dom/server');

var _server2 = _interopRequireDefault(_server);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// Used to map characters to HTML entities.
var htmlEscapes = {
  '&': '&amp;',
  '<': '&lt;',
  '>': '&gt;',
  '"': '&quot;',
  "'": '&#39;'
};

var accessor = function accessor(object) {
  return function (key) {
    return object[key];
  };
};
var unescapeHTMLCharReplacer = accessor(htmlEscapes);

var reUnescapedHtml = /[&<>"']/g;
var reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

var escape = function escape(string) {
  if (string && reHasUnescapedHtml.test(string)) {
    return string.replace(reUnescapedHtml, unescapeHTMLCharReplacer);
  }

  return string;
};

var componentToString = function componentToString(key, elt) {
  if (!_react2.default.isValidElement(elt)) return elt;

  try {
    return _server2.default.renderToStaticMarkup(elt);
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('In gandi.translate, unable to render component ' + key, err);
    return elt;
  }
};

function enhanceTranslate(namespace, translate) {
  /**
  * Wrap Counterpart translate function for more features.
  * @param  {String} message   Message to translate
  * @param  {Object} options   Options for the translation
  * @return {String}           Translated string
  */
  function enhancedTranslate(message) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    var parsedOptions = (0, _extends5.default)({
      withHTML: false,
      escapeParameters: false,
      scope: namespace,
      fallback: message
    }, options);

    // Resolve React components to static markup if needed
    parsedOptions = (0, _keys2.default)(parsedOptions).reduce(function (acc, key) {
      return (0, _extends5.default)({}, acc, (0, _defineProperty3.default)({}, key, componentToString(key, parsedOptions[key])));
    }, {});

    // Due to legacy, `withHTML` implicitly turns on parameter escaping.
    if ('withHTML' in options && !('escapeParameters' in options)) {
      parsedOptions.escapeParameters = options.withHTML;
    }

    if (parsedOptions.escapeParameters) {
      parsedOptions = (0, _keys2.default)(parsedOptions).reduce(function (acc, key) {
        var value = parsedOptions[key];
        var shouldEscape = typeof value === 'string' && ['scope', 'fallback'].indexOf(key) === -1;

        return (0, _extends5.default)({}, acc, (0, _defineProperty3.default)({}, key, shouldEscape ? escape(value) : value));
      }, {});
    }

    if (options.withHTML) {
      // wrap for dangerouslySetInnerHTML parameter
      return { __html: translate(message, parsedOptions) };
    }

    return translate(message, parsedOptions);
  }

  return enhancedTranslate;
}


//////////////////
// WEBPACK FOOTER
// ./~/@gandi/react-translate/dist/tools/enhanceTranslate.js
// module id = 515
// module chunks = 0